import { persistReducer } from 'redux-persist'
import persistConfig from '../persistConfig'
import authentication from './authentication'

export default {
  authentication: persistReducer(persistConfig, authentication),
}
